export const SINGLE_CAMPAIGN_BLOCK_VARIANT = 'single'

export const MULTI_CAMPAIGN_BLOCK_VARIANT = 'multiple'

export const BIG_CAMPAIGN_BLOCK_ITEM_VARIANT = 'bigCampaignBlockItem'

export const SMALL_CAMPAIGN_BLOCK_ITEM_VARIANT = 'smallCampaignBlockItem'

export const SMALL_CAMPAIGN_BLOCK_ITEM_VARIANT_WITH_IMAGE_ON_TOP_VARIANT = 'smallCampaignBlockItemWithImageOnTop'
